(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this._onScrollBound = this.onScroll.bind(this);
      this._ticking = false;
      this._lastMeasuredHeight = 0;
      this._resizeObserver = null;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.lastScrollTop = 0;
      this.scrollThreshold = 150;

      this._resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          this._updateHeaderHeight(entry.target.offsetHeight);
        }
      });
      this._resizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      window.addEventListener('scroll', this._onScrollBound, { passive: true });
      this.createObserver();
    }

    _updateHeaderHeight(h) {
      if (h > 0 && Math.abs(h - this._lastMeasuredHeight) > 2) {
        this._lastMeasuredHeight = h;
        document.documentElement.style.setProperty('--header-height', `${h}px`);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScrollBound);
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
      }
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }

    createObserver() {
      this._observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      this._observer.observe(this.header);
    }

    onScroll() {
      if (!this._ticking) {
        window.requestAnimationFrame(() => {
          this._update();
          this._ticking = false;
        });
        this._ticking = true;
      }
    }

    _update() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const stickyType = this.getAttribute('data-sticky-type');

      if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
      } else {
        this.header.classList.add('scrolled-past-header');
      }

      if (stickyType === 'on-scroll-up') {
        if (scrollTop > this.lastScrollTop && scrollTop > this.scrollThreshold) {
          this.header.classList.add('header-scrolled-down');
          this.header.classList.remove('header-scrolled-up');
        } else {
          this.header.classList.remove('header-scrolled-down');
          this.header.classList.add('header-scrolled-up');
        }
      }
      this.lastScrollTop = scrollTop;
      this.currentScrollTop = scrollTop;
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  class ShefsHeaderPredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
      this.searchTerm = '';
      this.debounceTimeout = null;
      this.isOpen = false;
      this._abortController = null;
      this._onDocClickBound = this.onDocumentClick.bind(this);
      this._onInputBound = this.debounceSearch.bind(this);
      this._onFocusBound = this.onFocus.bind(this);
      this._onKeydownBound = this.onKeydown.bind(this);

      if (!this.input || !this.predictiveSearchResults) return;

      this.setupEventListeners();
    }

    setupEventListeners() {
      this.input.addEventListener('input', this._onInputBound);
      this.input.addEventListener('focus', this._onFocusBound);
      this.input.addEventListener('keydown', this._onKeydownBound);
      document.addEventListener('click', this._onDocClickBound);

      this.predictiveSearchResults.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    }

    disconnectedCallback() {
      if (this.input) {
        this.input.removeEventListener('input', this._onInputBound);
        this.input.removeEventListener('focus', this._onFocusBound);
        this.input.removeEventListener('keydown', this._onKeydownBound);
      }
      document.removeEventListener('click', this._onDocClickBound);
      clearTimeout(this.debounceTimeout);
      if (this._abortController) {
        this._abortController.abort();
      }
    }

    debounceSearch(event) {
      this.searchTerm = event.target.value;

      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        this.performSearch();
      }, 300);
    }

    onFocus() {
      if (this.searchTerm.length > 0) {
        this.performSearch();
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.isOpen) {
        this.close();
        this.input.blur();
      }
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.close();
      }
    }

    performSearch() {
      if (this.searchTerm.length < 3) {
        this.close();
        return;
      }

      if (this._abortController) {
        this._abortController.abort();
      }
      this._abortController = new AbortController();

      const searchUrl = `${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(this.searchTerm)}&resources[type]=product,article,page&resources[limit]=10&section_id=predictive-search`;

      fetch(searchUrl, { signal: this._abortController.signal })
        .then(response => response.text())
        .then(text => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search')
            ?.innerHTML;

          if (resultsMarkup) {
            this.predictiveSearchResults.innerHTML = resultsMarkup;
            this.open();
          } else {
            this.close();
          }
        })
        .catch(error => {
          if (error.name !== 'AbortError') {
            console.error('Predictive search error:', error);
          }
          this.close();
        });
    }

    open() {
      this.predictiveSearchResults.classList.add('is-active');
      this.input.setAttribute('aria-expanded', 'true');
      this.isOpen = true;
    }

    close() {
      this.predictiveSearchResults.classList.remove('is-active');
      this.input.setAttribute('aria-expanded', 'false');
      this.isOpen = false;
    }
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', ShefsHeaderPredictiveSearch);
  }

  document.addEventListener('DOMContentLoaded', function() {
    const disclosureButtons = document.querySelectorAll('.localization-form .disclosure__button');

    disclosureButtons.forEach(button => {
      const flagImg = button.querySelector('img');
      const arrowSvg = button.querySelector('svg');

      if (flagImg && arrowSvg && !button.querySelector('.flag-container')) {
        const flagContainer = document.createElement('span');
        flagContainer.className = 'flag-container';
        flagContainer.appendChild(flagImg);
        flagContainer.appendChild(arrowSvg);
        button.insertBefore(flagContainer, button.firstChild);
      }
    });

    function setupClearSearchButtons() {
      const searchInputs = document.querySelectorAll('.desktop-search .search__input, .mobile-search .search__input');

      searchInputs.forEach(input => {
        if (input.dataset.clearInitialized === 'true') return;
        input.dataset.clearInitialized = 'true';

        const clearButton = input.closest('.field')?.querySelector('.search-clear-button');
        const mobileCancelButton = input.closest('.mobile-search')?.querySelector('.mobile-search-cancel-button');

        function toggleClearButton() {
          const hasValue = input.value.length > 0;
          if (clearButton) {
            clearButton.classList.toggle('visible', hasValue);
            input.classList.toggle('has-value', hasValue);
          }
          if (mobileCancelButton) {
            mobileCancelButton.classList.toggle('visible', hasValue);
          }
        }

        toggleClearButton();

        input.addEventListener('input', toggleClearButton);
        input.addEventListener('change', toggleClearButton);

        const clearAction = (e) => {
          e.preventDefault();
          e.stopPropagation();

          input.value = '';
          input.classList.remove('has-value');
          clearButton?.classList.remove('visible');
          mobileCancelButton?.classList.remove('visible');

          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.focus();

          const predictiveSearch = input.closest('predictive-search');
          if (predictiveSearch) {
            const resultsContainer = predictiveSearch.querySelector('[data-predictive-search]');
            if (resultsContainer) {
              resultsContainer.classList.remove('is-active');
              input.setAttribute('aria-expanded', 'false');
            }
          }
        };

        clearButton?.addEventListener('click', clearAction);
        mobileCancelButton?.addEventListener('click', clearAction);
      });
    }

    setupClearSearchButtons();

    document.addEventListener('shopify:section:load', function() {
      setTimeout(setupClearSearchButtons, 500);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
